var React = require('react');

function Pricemob (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M79.5021 542.157C-40.0686 408.419 -28.584 203.072 105.154 83.5017C238.891 -36.069 444.238 -24.5843 563.809 109.153L79.5021 542.157Z","fill":"#1F4D67"}));
}

Pricemob.defaultProps = {"width":"334","height":"131","viewBox":"0 0 334 131","fill":"none"};

module.exports = Pricemob;

Pricemob.default = Pricemob;
